/**
 * MADERINCO-CARGA-CATALOGO-UI-T1 -- reglas del boton "Cargar catalogo aprobado" (sin DOM, para el check).
 *
 * Contrato: POST /api/v1/presupuestos/plantilla/cargar?negocio= de nexo-api (MADERINCO-SECCIONES-API-T1).
 * [Authorize] + [RequireManager]; solo el negocio demo (PUERTA_CERRADA fuera). El cuerpo es el JSON TAL CUAL:
 * la API calcula el sha256 sobre el texto recibido y solo entra el aprobado (otro = 409 CATALOGO_NO_APROBADO).
 * Por eso el panel manda el File como cuerpo y nunca lo lee, lo parsea ni lo reformatea.
 * 200 = {catalogoSha, secciones, items, relaciones, itemsNuevos}; repetir el mismo archivo = 0 nuevos.
 *
 * @module application/presupuestos/cargaCatalogo
 */

/** Tope del panel antes de gastar el viaje: el catalogo aprobado pesa ~415 KB. */
export const MAX_BYTES_CATALOGO = 5 * 1024 * 1024;

/** Lo ve quien la API deja pasar: gerente o admin (y dev). El resto ni ve el boton. */
export function puedeCargarCatalogo(rol) {
  return rol === 'admin' || rol === 'manager' || rol === 'dev';
}

/** null = se puede mandar; si no, la frase de por que no. No lee el contenido. */
export function revisarArchivo(file) {
  if (!file) return 'Elige el archivo del catálogo.';
  if (!/\.json$/i.test(file.name || '')) return 'El catálogo es un archivo .json.';
  if (!(file.size > 0)) return 'Ese archivo está vacío.';
  if (file.size > MAX_BYTES_CATALOGO) return 'Ese archivo pesa demasiado para ser el catálogo.';
  return null;
}

const num = (v) => (Number.isFinite(Number(v)) ? Number(v) : 0);

/** La respuesta de la API en una forma (tolera camelCase y PascalCase). */
export function resumenDeCarga(data) {
  const d = data?.data ?? data ?? {};
  const sha = String(d.catalogoSha ?? d.CatalogoSha ?? '');
  return {
    secciones: num(d.secciones ?? d.Secciones),
    items: num(d.items ?? d.Items),
    relaciones: num(d.relaciones ?? d.Relaciones),
    nuevos: num(d.itemsNuevos ?? d.ItemsNuevos),
    sha,
    sha16: sha.slice(0, 16),
  };
}

/** Una linea para el resultado: dice si fue carga nueva o repeticion. */
export function fraseDeCarga(r) {
  const base = `${r.secciones} secciones y ${r.items} ítems`;
  return r.nuevos > 0
    ? `Catálogo cargado: ${base}, ${r.nuevos} nuevos.`
    : `Ya estaba cargado: ${base}, 0 nuevos (no se duplicó nada).`;
}

/** La causa, por codigo de la API (el ProblemDetails) o del cliente. */
export function fraseDelError(error) {
  const code = String(error?.code || '');
  const detalle = error?.detalle ? ` (${error.detalle})` : '';
  switch (code) {
    case 'CATALOGO_NO_APROBADO': return `Ese no es el catálogo aprobado: no se cargó nada${detalle}.`;
    case 'CATALOGO_INVALIDO': return `El catálogo tiene problemas: no se cargó nada${detalle}.`;
    case 'PUERTA_CERRADA': return 'La carga solo está abierta en el negocio demo. Cambia el negocio con el selector de arriba.';
    case 'SIN_SESION': return 'Tu sesión venció: vuelve a entrar y repite la carga.';
    case 'FORBIDDEN': return 'Solo un gerente o un administrador del negocio puede cargar el catálogo.';
    case 'NOT_IMPLEMENTED': return 'La carga todavía no está publicada en la API.';
    case 'NETWORK': return 'No pudimos hablar con la API ahora. Intenta en un momento.';
    default: return `No pudimos cargar el catálogo (${code || 'error'})${detalle}.`;
  }
}
